	//this is the button
	var acc = document.getElementsByClassName("Faq__Question");
	var i;

	for (i = 0; i < acc.length; i++) {
		//when one of the buttons are clicked run this function
	  acc[i].onclick = function() {
		//variables
		var panel = this.nextElementSibling;
		var coursePanel = document.getElementsByClassName("Faq__AnswerWrapper");
		var courseAccordion = document.getElementsByClassName("Faq__Question");
		var courseAccordionActive = document.getElementsByClassName("Faq__Question active");

		/*if pannel is already open - minimize*/
		if (panel.style.maxHeight){
			//minifies current pannel if already open
			panel.style.maxHeight = null;
			//removes the 'active' class as toggle didnt work on browsers minus chrome
			this.classList.remove("active");
		} else { //pannel isnt open...
			//goes through the buttons and removes the 'active' css (+ and -)
			for (var ii = 0; ii < courseAccordionActive.length; ii++) {
				courseAccordionActive[ii].classList.remove("active");
			}
			//Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
			for (var iii = 0; iii < coursePanel.length; iii++) {
			  this.classList.remove("active");
			  coursePanel[iii].style.maxHeight = null;
			}
		  //opens the specified pannel
		  panel.style.maxHeight = panel.scrollHeight + "px";
		  //adds the 'active' addition to the css.
		  this.classList.add("active");
		} 
	  }//closing to the acc onclick function
	}//closing to the for loop.
    $(".first_element").trigger('click');

	//Only open on the FAQ help page, this template is being used on the delivery page also - but we don't want the accordion to automatically open on load for this page
	if(window.location.pathname.includes("/help")){
		$('.Faq__Question').first().trigger('click'); // To open the first accordian in page load 
	}

	if(window.storeRegion == "DAYROW") {
		var onSuccess = function(geoipResponse) {
		  window.countryCode = geoipResponse.country.iso_code;
		  if(window.countryMarkets[window.countryCode] === undefined){
			return;
		  }
		  var countryItems = document.querySelectorAll('.Faq__row');
		  var firstExpanded = false;
		  var countryShow = window.countryMarkets[window.countryCode];
		  for(var i = 0; i < countryItems.length; i++){
			var countryItem = countryItems[i];
			var countryName = countryItem.querySelector('.Faq__Question');
			if(countryShow.includes(countryName.innerText)){
			  if(firstExpanded == false){
				countryName.click();
				firstExpanded = true;
			  }
			} else {
			  countryItem.style.display = "none";
			}
		  }
		  
		}
	  
		// If we get an error, we will display an error message
		var onError = function(error) {
		  console.error(error);
		};
	  
		if(window.location.pathname == "/pages/shipping") {
		  geoip2.country(onSuccess, onError);
		}
	  }
